/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Tiles_portfolioItemsConnection$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type ItemsPaginationWrapper_portfolioNode$ref = any;
export type ItemsPaginationWrapper_portfolioNode = {
    readonly id: string;
    readonly items: {
        readonly totalResults: number | null;
        readonly numberOfPages: number | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly endCursor: string | null;
        };
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
                readonly item: {
                    readonly serviceId: string | null;
                    readonly vertical: VerticalType | null;
                    readonly seller: {
                        readonly serviceId: string | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": Tiles_portfolioItemsConnection$ref;
    } | null;
    readonly " $refType": ItemsPaginationWrapper_portfolioNode$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ItemsPaginationWrapper_portfolioNode",
        "type": "PortfolioV2",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "items"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "first",
                "type": "Int"
            },
            {
                "kind": "RootArgument",
                "name": "after",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "searchTerm",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy",
                "type": "PortfolioItemsSortByTypes"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": "items",
                "name": "__ItemsRefetchWrapper_items_connection",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "searchTerm",
                        "variableName": "searchTerm"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                    }
                ],
                "concreteType": "PortfolioItemsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalResults",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "numberOfPages",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemsEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioItemV2",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "vertical",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "seller",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Seller",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Tiles_portfolioItemsConnection",
                        "args": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '27b667db473dedc2858d9b66888c01e0';
export default node;
